import axios from "axios";
import { ERR_NETWORK, NO_RESPONSE_RECEIVED, UNABLE_TO_REACH_SERVER, UNKNOWN_ERROR } from "./constants";

export const handleError = (error: any) => {


  if (axios.isAxiosError(error)) {

    if (error.code === ERR_NETWORK) {
      return UNABLE_TO_REACH_SERVER;
    }

    if (error.response) {
      const { data } = error.response;
      return data?.message || `Unexpected error: ${error.response.status}`;
    }

    if (error.request) {
      return NO_RESPONSE_RECEIVED;
    }

    return `${error.message}`;
  }

  return error?.cause || error?.message || UNKNOWN_ERROR;
};
